import { useContext, useMemo } from "react";
import { ModalSettingContext } from "../../index";
import Select from "@UI/New/Select";
import { usersAPI } from "@/api";
import { useApiSearch } from "@/hooks/useApiSearch";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import useRoles from "@/hooks/useRoles";

export const Childrens = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    const { isSeminarian } = useRoles();
    const params = useMemo(() => {
        return (
            {
                'role': `children`,
                'per-page': false,
                'type': 'private',
                ...(state.direction && {'directionChild': state.direction}),
                'teacher_id': state.speaker_id,
                'per-page': 1000
            }
        )
    }, [state.direction, state.speaker_id]);
    // }, [state.direction, state.tariff]);

    const {
        data: childrens,
        loading,
        searchQuery,
        setSearchQuery
    } = useApiSearch({
        apiMethod: usersAPI.searchUsersForSelect,
        responseKey: 'data',
        searchKey: `name`,
        params,
        notSendRequest: (!state.speaker_id || !state.direction),
        minQueryLength: 0
    });

    const fieldsCourse = {
        // tokenSeparators: [','],
        // mode: "multiple",
        loading,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: false,
        onChange: value => setFieldInState(
            {
                field: 'childrens', 
                value: value ? [value] : []
            }
        ),
        // options: (!state.direction || !state.tariff || loading) ? [] : childrens.map(children => ({label: children.name, value: children.id})),
        options: (!state.direction || !state.speaker_id || loading) ? [] : childrens,
        value: state.childrens[0],
        placeholder: 'Выберите ученика',
        onSearch: setSearchQuery,
        notFoundContent: (!state.direction || !state.speaker_id) ? isSeminarian ? 'Сначала выберите курс' : 'Сначала выберите курс и педагога' : "Ученики не найдены"
    };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsCourse} 
        />
    );
};